import {
  addMakeInvoice,
  editMakeInvoice,
  getInvoiceIdentifyContent,
  getProjectTypes,
  someInvoiceCompleteTask,
} from '@/services/financial/FinancialController';
import { getAdminGroupList } from '@/services/user/UserController';
import { ActionType } from '@ant-design/pro-components';
import { useRequest } from 'ahooks';
import { debounce } from 'lodash-es';
import { useEffect, useRef, useState } from 'react';

export default () => {
  const [loading, setLoading] = useState(false);
  const actionRef = useRef<ActionType>();

  // 编辑开票任务
  const updateMakeInvoice = useRequest(editMakeInvoice, {
    manual: true,
  });
  // 发起开票任务
  const insertMakeInvoice = useRequest(addMakeInvoice, {
    manual: true,
  });
  const fetchProjectTypes = useRequest(getProjectTypes, {
    manual: true,
  });
  // 提交完成开票任务
  const updateSomeInvoiceCompleteTask = useRequest(someInvoiceCompleteTask, {
    manual: true,
  });

  const fetchInvoiceIdentifyContent = useRequest(getInvoiceIdentifyContent, {
    manual: true,
  });
  // 获取用户组列表
  const fetchAdminGroupList = useRequest(getAdminGroupList, {
    manual: true,
  });

  /**
   *  需要监听Loading状态的方法
   *  仅 useRequest 返回的函数可以录入
   */
  const effectLoadingList = [
    updateMakeInvoice,
    insertMakeInvoice,
    fetchProjectTypes,
    updateSomeInvoiceCompleteTask,
    fetchInvoiceIdentifyContent,
  ];

  /**
   * 监听处理loading状态
   */
  useEffect(() => {
    // 防抖处理的函数，延迟500ms后执行setLoading
    const debouncedSetLoading = debounce((loading: boolean) => {
      setLoading(loading);
    }, 0);
    const bool = effectLoadingList.some((item) => {
      return item.loading;
    });
    debouncedSetLoading(bool);
    // 清理防抖函数
    return () => {
      debouncedSetLoading.cancel();
    };
  }, [
    updateMakeInvoice,
    insertMakeInvoice,
    fetchProjectTypes,
    updateSomeInvoiceCompleteTask,
    fetchInvoiceIdentifyContent,
  ]);

  return {
    actionRef,
    loading,
    setLoading,
    updateMakeInvoice,
    insertMakeInvoice,
    fetchProjectTypes,
    updateSomeInvoiceCompleteTask,
    fetchInvoiceIdentifyContent,
  };
};
